import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as api from '../../../api';
import { exportCSVFDCandidats, exportCSVFDJurys } from '../../../Components/AdminPanels/CSVExporter';
// import FDCategories from './FDCategories';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import FDCompilationJury from '../../../Components/AdminPanels/FD1002023/FDCompilationJury';
import { Link } from 'react-router-dom';
import { FD100MultiSelectOptions } from '../../Utils/Listings';
import FabFrIndicator from '../../Atoms/FabFrIndicator';
import Popup from '../../Atoms/Popup';
import H2 from '../../Atoms/H2';
import BlueButton from '../../Atoms/BlueButton';
import { getEventDesignerDisplayName, getEventDesignerProfileLink } from '../../../Components/AdminPanels/utils/eventDesignerHelpers';

const RatingLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    border-top: 1px solid #ccc;

    > .projinfo {
        width: 32%;

        a{
            color: black;
            text-decoration: none;
            &:hover{
                color: blue;
            }
        }

        > select {
            transform: translateX(-15px);
        }
    }

    .details_button {
        cursor: pointer;
        font-size: 24px;
        position: relative;

        &:hover {
            color: blue;

            &::after {
                content: "Voir le détail des notes et commentaires";
                position: absolute;
                left: 25px;
                top: -10px;
                background-color: #00000088;
                color: white;
                padding: 5px;
                border-radius: 5px;
                font-size: 12px;
            }
        }
    }
`

const ColorBlock = styled.div`
    width: 50px;
    height: 30px;
    border-radius: 5px;
`

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 100px; 
  
  > div:first-child {
    width: 32%; /* Same as .projinfo */
  }
  
  > div:nth-child(2) {
    position: relative;
  }
`

const TableHeader = styled.div`
    position: absolute;
    left: 0;
    bottom: 0;
    width: 400px;

    > span {
        position: absolute;
        transform: rotate(-45deg);
        transform-origin: 0;
        bottom:0;
        left: 0;
    }
`

const RatingsDetailsTable = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 5fr;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;

    > div {
        padding: 10px;
        border: 1px solid #ccc;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`

const CompilationLine = ({project,ratings,updateProjetStatusFinal,updateProjetCategorie}) => {
    const { i18n } = useTranslation();
    let color = "lightgrey"
    if(project.projet.statusFinal === "validé"){
        color = "green"
    }
    if(project.projet.statusFinal === "refusé"){
        color = "red"
    }

    const [showDetails, setShowDetails] = useState(false);

    // function totalMentionsForProj(_ratings){
    //     return _ratings.reduce((total,rating) => total + ((rating.rating.Innovation_durabilité === "checked" ? 1 : 0) + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0) + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0)),0)
    // }

    // //make the string lowercase, and the first letter uppercase
    // function quentinCase(string){
    //     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    // }

    //make the string lowercase, and the first letter of each word uppercase
    function quentinCase(string){
        return string.toLowerCase().split(' ').map((s) => s.charAt(0).toUpperCase() + s.substring(1)).join(' ');
    }

    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100("fr");

    //there are two types of categories, espace and objet, we merge them, but we need to remove the duplicates
    const FDCategories = [
        ...tyoplogieEspaceFD100,
        ...typologieObjetFD100,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);

    return (<>
        <RatingLine>
            <div className='projinfo'>
                <a href={getEventDesignerProfileLink(project.projet, project.user)} target="_blank" rel="noreferrer">
                    {getEventDesignerDisplayName(project.projet, project.user)}
                </a><br/>
                <div style={{display:"flex", alignItems:"center"}}>
                    <a style={{fontWeight:"100"}} href={"/admin/events/fdficheprojet?email="+project.user.user.email+"&pid="+project.user.participation._id+"&projid="+project.projet._id+"&edit-mode=true"} target="_blank" rel="noreferrer">{quentinCase(i18n.language !== 'fr' && project.projet.name_en ? project.projet.name_en : project.projet.name)}</a>
                    {project.projet.fabrication_fr === "oui" && <FabFrIndicator/>}
                </div>
                <select value={project.projet.typologie || ""} onChange={(e)=>{updateProjetCategorie(project.projet.participationId,project.projet._id,e.target.value)}}>
                    <option value="">Catégorie</option>
                    {FDCategories.map((cat,i) => 
                        <option value={cat.value} key={i}>{cat.label}</option>
                    )}
                </select>
            </div>
            <div style={{display:"flex",gap:"50px", alignItems:"center"}}>
                <span>{ratings.reduce((totalStars,rating) => totalStars + rating.rating.stars || 0,0)}</span>
                <span>{ratings.reduce((total,rating) => total + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0),0)}</span>
                <span>{ratings.reduce((total,rating) => total + (rating.rating.commentaire ? 1 : 0),0)}</span>
                {/* <span>{ratings.reduce((total,rating) => total + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0),0)}</span>
                <span>{ratings.reduce((total,rating) => total + (rating.rating.Innovation_durabilité === "checked" ? 1 : 0),0)}</span>
                <span>{totalMentionsForProj(ratings)}</span> */}
                <span className='details_button' onClick={() => setShowDetails(true)}>☰</span>
            </div>
            <div style={{display:"flex",gap:"50px", alignItems:"center"}}>
                <select value={project.projet.statusFinal} onChange={(e)=>{updateProjetStatusFinal(project.projet.participationId,project.projet._id,e.target.value)}}>
                    <option value="">À valider</option>
                    <option value="validé">Validé</option>
                    <option value="refusé">Refusé</option>
                </select>
                <ColorBlock style={{backgroundColor:color}}/>
            </div>
        </RatingLine>
        {showDetails &&
            <Popup close={() => setShowDetails(false)} style={{maxWidth:"1000px"}}>
                <H2>{quentinCase(i18n.language !== 'fr' && project.projet.name_en ? project.projet.name_en : project.projet.name)}</H2>
                <span>{getEventDesignerDisplayName(project.projet, project.user)}</span>
                <RatingsDetailsTable>
                    <div>Jury</div>
                    <div>Note</div>
                    <div>Coup de Coeur</div>
                    <div>Commentaire</div>
                    {ratings.map((rating,i) => <React.Fragment key={i}>
                        <div>
                            <span>{rating.rating?.jury?.first_name} {rating.rating?.jury?.last_name}</span>
                            <span style={{fontWeight:"300"}}>{rating.rating?.jury?.email}</span>
                        </div>
                        <div>
                            <span>{rating.rating?.stars || 0} / 3</span>
                        </div>
                        <div>
                            <span>{rating.rating?.Coup_de_coeur === "checked" ? "✔" : ""}</span>
                        </div>
                        <div>
                            <span style={{fontWeight:"300"}}>{rating.rating?.commentaire}</span>
                        </div>
                    </React.Fragment>)}
                </RatingsDetailsTable>
                <BlueButton onClick={() => setShowDetails(false)}>Fermer</BlueButton>
            </Popup>
        }
    </>)
}
  
const FD100CompilationJury = () => {

    const [event, setEvent] = useState(null);
    const [allParticipations, setAllParticipations] = useState([]);
    const [allProjects, setAllProjects] = useState([]);
    const [ratings, setRatings] = useState([]);
    const [allJuries, setAllJuries] = useState([]);
    const [tri, setTri] = useState('note_et_mention');
    const [filtre, setFiltre] = useState('');

    //parse eid from url
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                response.data.displaytype = (response.data.type === "sde" || response.data.type === "sdo") ? "Speed Dating" : "FD 100";
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    const getAllParticipations = React.useCallback(() => {
        if (!event) return;
        
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            // console.log("response.data de get all participations");
            // console.log(response.data);

            const _allParticipations = response.data.map(participation => {
                return {
                    ...participation,
                    data: {
                        projets : participation.participation.data.projets.map(projet_id => {
                            return participation.company.projects.find((p) => p._id === projet_id)
                        }
                    )}
                }
            })

            console.log("_allParticipations processed")
            console.log(_allParticipations)

            setAllParticipations(_allParticipations);
            let _allProjetcs = []
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id)

                        if(project && project.status === "validé") _allProjetcs.push({projet : {...project,participationId:user.participation._id}, user : user})
                    })
                }
            })
            console.log(_allProjetcs)
            setAllProjects(_allProjetcs)
        }).catch((error) => {
            console.log(error);
        });
    }, [event]);

    useEffect(() => {
        getAllParticipations()
    }, [getAllParticipations])

    //get all jury's ratings
    useEffect(() => {
        if (!event) return;
        api.getAllJuriesForEvent({ eventId: event._id }).then((response) => {
            console.log("response.data de get all juries");
            console.log(response.data);
            let _allJuries = response.data.sort((a,b) => a.last_name.localeCompare(b.last_name));
            setAllJuries(_allJuries);
            let _ratings = [];
            _allJuries.forEach(jury => {
                if (jury.juryNotes) {
                    jury.juryNotes.forEach(rating => {
                        rating.jury = jury
                        let _projetIndex = _ratings.findIndex(r => r.id === rating.participationId + rating.projetId)
                        if (_projetIndex === -1) {
                            _ratings.push({id : rating.participationId + rating.projetId, ratings : [{rating}]})
                        } else {
                            _ratings[_projetIndex].ratings.push({rating})
                        }
                    })
                }
            })
            console.log("_ratings");
            console.log(_ratings);
            setRatings(_ratings)
        }).catch((error) => {
            console.log(error);
        });
    }, [event])

    //update projet status final
    function updateProjetStatusFinal(participationId, projetId, status){
        api.updateProjetStatusFinal(participationId, projetId, status).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    //update projet categorie
    function updateProjetCategorie(participationId, projetId, categorie){
        api.updateProjetCategorie(participationId, projetId, categorie).then((response) => {
            console.log(response.data);
            getAllParticipations()
        }).catch((error) => {
            console.log(error);
        });
    }

    function cumulNoteOfProj(project){
        const _ratings = ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []
        return _ratings.reduce((totalStars,rating) => totalStars + rating.rating.stars || 0,0)
    }

    function totalMentionsForProj(project){
        const _ratings = ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []
        return _ratings.reduce((total,rating) => total + ((rating.rating.Innovation_durabilité === "checked" ? 1 : 0) + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0) + (rating.rating.Art_de_vivre_à_la_française === "checked" ? 1 : 0)),0)
    }

    function filterByStatus(project){
        if(filtre === '' || (filtre === 'avalider' && !project.projet.statusFinal)){
            return true
        }
        return filtre === project.projet.statusFinal
    }

    const LauréatsForExport = () => {
        //returns all participations but only with validated projects (statusFinal === "validé")
        // const Lauréats = allParticipations.filter(part => part.participation?.data?.projets?.find(projet => projet.statusFinal === "validé"))
        return allParticipations.map(participation => {
            return {
                ...participation,
                data: {
                    projets : participation.data.projets.filter(projet => projet.statusFinal === "validé")
                }
            }
        }).filter(participation => participation.data.projets.length > 0)
    }

    if(!event){
        return (
            <Spinner/>
        )
    }

    if(event._id === "6418b274494e3ee26a9076ac"){
        return (
            <FDCompilationJury/>
        )
    }

    const tyoplogieEspaceFD100 = FD100MultiSelectOptions.tyoplogieEspaceFD100("fr");
    const typologieObjetFD100 = FD100MultiSelectOptions.typologieObjetFD100("fr");

    //there are two types of categories, espace and objet, we merge them, but we need to remove the duplicates
    const FDCategories = [
        ...tyoplogieEspaceFD100,
        ...typologieObjetFD100,
    ].filter((cat, index, self) => self.findIndex((t) => t.value === cat.value) === index);

    function getUniqueParticipationsCount(){
        let participations = []
        allProjects.forEach(project => {
            if(!participations.includes(project.projet.participationId)){
                participations.push(project.projet.participationId)
            }
        })
        return participations.length
    }

    return (
        <div>
            {event ?
                <div>
                    <Link to="/admin/events"><button>← Retour aux événements</button></Link><br/><br/>
                    <h1>{event.title_fr}</h1>
                    <h2>Synthèse des votes du jury</h2>
                    <br/>
                    <div style={{textAlign:"right"}}>
                        <Link to="/admin/events/fdjuryprogress">
                            <button style={{background: '#2196f3', color: 'white', marginBottom: '10px'}}>
                                📊 Voir le Suivi des Votes en Temps Réel
                            </button>
                        </Link><br/>
                        <Link to={`/admin/events/fd100architectureratings?eid=${event._id}`}>
                            <button style={{background: '#ff9800', color: 'white', marginBottom: '10px'}}>
                                🏛️ Voir les Notes du Jury Architecture
                            </button>
                        </Link><br/>
                        <Link to={`/admin/events/fd100mentioncontractratings?eid=${event._id}`}>
                            <button style={{background: '#9c27b0', color: 'white', marginBottom: '10px'}}>
                                📋 Voir les Notes du Jury Mention Contract
                            </button>
                        </Link><br/>
                        <Link to={`/admin/events/fd100projects?eid=${event._id}`}>
                            <button style={{background: '#4caf50', color: 'white', marginBottom: '10px'}}>
                                🗂️ Voir tous les projets en compétition
                            </button>
                        </Link><br/>
                        <button onClick={() => exportCSVFDCandidats(LauréatsForExport(),"lauréats.csv")}>Export des lauréats</button><br/><br/>
                        <button onClick={() => exportCSVFDJurys(ratings,allJuries,allProjects,"jury.csv")}>Export des notes et commentaires des jurys</button><br/><br/>
                    </div>
                    <br/>
                    <div className='flexinfos numbers'>
                        <b>{getUniqueParticipationsCount()}</b>
                        <b>{allProjects.length}</b>
                        <b>{allProjects.filter(proj => proj.projet.name && proj.projet.statusFinal === "refusé").length}</b>
                        <b>{allProjects.filter(proj => proj.projet.name && proj.projet.statusFinal !== "validé" && proj.projet.statusFinal !== "refusé").length}</b>
                        <b>{allProjects.filter(proj => proj.projet.statusFinal === "validé").length}</b>
                    </div>
                    <div className='flexinfos'>
                        <p>Candidats sélectionnés</p>
                        <p>Projets sélectionnés</p>
                        <p>Projets<br/>refusés</p>
                        <p>Projets<br/>à valider</p>
                        <p>Lauréats</p>
                    </div>
                    <br/>
                    <div>
                        <p>
                            <span>Tri : </span>
                            <select onChange={e => setTri(e.target.value)}>
                                <option value='note_et_mention'>Par cumul des notes et cumul des mentions</option>
                                <option value=''>Par catégorie</option>
                                <option value='note'>Par cumul des notes</option>
                                <option value='mention'>Par cumul des mentions</option>
                            </select>
                        </p>
                        <p>
                            <span>Filtre : </span>
                            <select onChange={e => setFiltre(e.target.value)}>
                                <option value=''>Tous</option>
                                <option value='avalider'>À valider</option>
                                <option value='validé'>Validés</option>
                                <option value='refusé'>Refusés</option>
                            </select>
                        </p>
                    </div>
                    <HeaderContainer>
                    <div></div>
                    <div style={{width:"420px"}}>
                        <TableHeader>
                        <span>Cumul des notes</span>
                        <span style={{left:"64px"}}>Cumul des mentions Coup de Coeur</span>
                        <span style={{left:"128px"}}>Commentaires</span>
                        </TableHeader>
                    </div>
                    <div></div>
                    </HeaderContainer>
                    {tri === 'note_et_mention' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => totalMentionsForProj(b) - totalMentionsForProj(a)).sort((a,b) => cumulNoteOfProj(b) - cumulNoteOfProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === 'note' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => cumulNoteOfProj(b) - cumulNoteOfProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === 'mention' && <>
                        {allProjects.filter(filterByStatus).sort((a,b) => totalMentionsForProj(b) - totalMentionsForProj(a)).map((project,j) =>
                            <CompilationLine
                                key={j}
                                project={project}
                                ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                updateProjetStatusFinal={updateProjetStatusFinal}
                                updateProjetCategorie={updateProjetCategorie}
                            />
                        )}
                    </>}
                    {tri === '' && <>
                        {FDCategories.filter(cat => allProjects.filter(filterByStatus).filter(proj => proj.projet.typologie === cat.value).length > 0).map((cat,i) => 
                            <div key={i}>
                                <div className='thin' style={{backgroundColor:"#eeeeee",position:"sticky",top:"0",zIndex:"1"}}>{cat.value}</div>
                                {allProjects.filter(filterByStatus).filter(proj => proj.projet.typologie === cat.value).map((project,j) =>
                                    <CompilationLine
                                        key={j}
                                        project={project}
                                        ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                        updateProjetStatusFinal={updateProjetStatusFinal}
                                        updateProjetCategorie={updateProjetCategorie}
                                    />
                                )}
                            </div>
                        )}
                        {allProjects.filter(filterByStatus).filter(proj => !proj.projet.typologie).length > 0 &&
                            <div>
                                <div className='thin' style={{backgroundColor:"#eeeeee"}}>Pas de catégorie attribuée</div>
                                {allProjects.filter(filterByStatus).filter(proj => !proj.projet.typologie).map((project,j) =>
                                    <CompilationLine
                                        key={j}
                                        project={project}
                                        ratings={ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || []}
                                        updateProjetStatusFinal={updateProjetStatusFinal}
                                        updateProjetCategorie={updateProjetCategorie}
                                    />
                                )}
                            </div>
                        }
                    </>}
                </div>
            :
                <Spinner/>
            }
        </div>
    );
};

export default FD100CompilationJury;